import { styled } from "@mui/material";

export const ClientStepRoot = styled("div")`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 32px;
    width: 100%;
    min-height: 100%;
    max-width: 680px;
    margin: auto;
    box-sizing: border-box;

    form {
        display: flex;
        flex-direction: column;
        gap: 24px;
        padding-bottom: 24px;
    }

    & footer {
        display: flex;
        justify-content: space-between;
    }

    & .MuiFormHelperText-root {
        bottom: -20px;
        position: absolute;
    }
    
  
      
`;

export const ClientStepForm = styled("form")`
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding-bottom: 48px;
    box-sizing: border-box;

    & :nth-child(4) {
        display: grid;
        grid-template-columns: 2.65rem 1fr;

    }
`;

export default ClientStepRoot;
